
import React, { useState, useEffect } from 'react'
// import products from '../products'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { Button, Col, FormControl, Image, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import Rating from '../components/Rating';

import { useDispatch, useSelector } from 'react-redux'
import { fetchProducts } from '../actions/productActions';

import Loader from '../components/Loader'
import Message from '../components/Message'
import { BASE_URL } from '../constants/urlConstants';
import Product from '../components/Product';

function ProductsScreen() {
  const history = useNavigate()
  const { id } = useParams()
  const dispatch = useDispatch()
  const listProducts = useSelector(state => state.listProduct)
  const { error, loading, products } = listProducts

//   const productDetails = useSelector(state => state.productDetails)
//   const { error, loading, product } = productDetails


  useEffect(() => {
    dispatch(fetchProducts(id))
    
  }, [dispatch,id])

 

  return (
    <div>
      <Link className='btn btn-light my-3' to="/">go back</Link>

      {loading ? <Loader />
        : error ? <Message variant='danger' text={error} />
          :
          (<Row>
             {products.map(product => (
                            <Col key={product._id} sm={12} md={6} lg={4} xl={3}>
                              <Product product={product} />
                            </Col>
                          ))}

           
          </Row>


          )
      }


    </div>
  )
}

export default ProductsScreen
